export const UNSUBSCRIBE_ROUTE = {
  DEFAULT: '',
  name: 'unsubscribe',
  route(): string[] {
    return ['/', this.name];
  },
  UNSUBSCRIBE_WITH_EMAIL: {
    name: ':email',
    route(email: string): string[] {
      return [...UNSUBSCRIBE_ROUTE.route(), email];
    }
  }
};
